import styled, { css } from 'styled-components';

/** The chips under the banner's title, wrapping onto as many rows as needed. */
export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

/**
 * One problem or missing item: white on the banner's tint, a dot in its
 * severity colour, a few words. A button when it opens something; a plain
 * chip (still with its tooltip) when there is nothing to open.
 */
export const Chip = styled.button<{ $clickable: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: 6px 12px;
  border: 1px solid ${({ theme }) => theme.mediumGray};
  border-radius: 16px;
  background: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.darkGray};
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  cursor: default;
  transition: ${({ theme }) => theme.transitions.ease200ms};

  ${({ $clickable, theme }) =>
    $clickable &&
    css`
      cursor: pointer;

      &:hover {
        border-color: ${theme.primary};
      }
    `}

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primary};
    outline-offset: 2px;
  }
`;

/** A long problem title ellipses; the tooltip and the detail have it all. */
export const ChipText = styled.span`
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ChipDot = styled.span<{ $color: string }>`
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
`;
